<template>
  <div class="login-form">
    <a-form
      :model="formState"
      name="basic"
      :label-col="{ span: 0 }"
      :wrapper-col="{ span: 24 }"
      autocomplete="off"
      class="w-[400px]"
      @finish="onFinish"
    >
      <h1 class="mt-0 !mb-30px">绑定手机号</h1>
      <a-form-item
        name="mobile"
        :rules="[
          { required: true, message: $t('qing-shu-ru-shou-ji-hao') },
          { validator: validatePhone, trigger: 'blur' },
        ]"
      >
        <a-input
          v-model:value="formState.mobile"
          class="yy-input-xlg"
          :placeholder="$t('qing-shu-ru-shou-ji-hao')"
        />
      </a-form-item>
      <a-form-item
        name="sms_code"
        :rules="[
          { required: true, message: $t('qing-shu-ru-yan-zheng-ma') },
          {
            pattern: smsCodeReg,
            message: $t('6-wei-shu-zi-yan-zheng-ma'),
            trigger: 'blur',
          },
        ]"
      >
        <XCaptchaInput
          v-model:value="formState.sms_code"
          :placeholder="$t('qing-shu-ru-yan-zheng-ma')"
          :xLarge="true"
          :data="formState.mobile"
          :is-checked="true"
        />
      </a-form-item>

      <a-form-item :wrapper-col="{ offset: 0, span: 24 }" class="mt-[70px]">
        <a-button
          type="primary"
          :disabled="!canSubmit"
          html-type="submit"
          :loading="loading"
          class="yy-btn-xlg btn-shadow"
        >
          {{ $t('que-ren') }}
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script lang="ts" setup>
import { getUserInfo, postFeishuAccountCreate } from '@/api';
import { smsCodeReg, validatePhone } from '@/utils/form';
import { reactive } from 'vue';
import { useI18n } from 'vue-i18n';

const { t: $t } = useI18n();

interface FormState {
  mobile: string;
  sms_code: string;
}

const formState = reactive<FormState>({
  mobile: '',
  sms_code: '',
});
const { setAccountList, setSession, setUserInfo } = useChangeUser();
const showAccountType = useAccountType();
const loading = ref(false);
const router = useRouter();

const canSubmit = computed(() => {
  return formState.sms_code && formState.mobile;
});

const onFinish = async (values: any) => {
  loading.value = true;
  const urlObj = new URL(window.location.href);
  const code = urlObj.searchParams.get('code');
  try {
    const res = await postFeishuAccountCreate({
      ...values,
      code,
    });

    if (!res.code && res.data) {
      const { data } = res;
      // 用户账号列表
      setAccountList(data);

      // 用户token
      setSession(res.data[0]);
      const result = await getUserInfo();

      if (result?.data) {
        // 用户信息
        setUserInfo(result.data);
        location.href = '/workspace';
      }
      showAccountType.value = null;
    }
    loading.value = false;
  } catch (error) {
    loading.value = false;
  }
};
</script>

<style lang="scss" scoped>
.login-form {
  .ant-form-item {
    margin-bottom: 30px;
  }

  .login-btn {
    @apply bg-back-3 text-font-60 flex w-[264px] rounded-[8px] p-[2px] mx-auto;

    .btn-item {
      @apply w-[130px] text-center rounded-[8px] cursor-pointer;
      padding: 8px 16px;

      &.active {
        @apply text-font-1 bg-back-1 font-medium;
      }
    }
  }

  .btn-shadow {
    @apply w-full;
    box-shadow: 0px 36px 36px -20px rgba(105, 98, 255, 0.8);
  }
}
</style>
